import { W, H, R } from "./props";

const cap = (list) => (tt) => (list.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;
const bars = (ctx, tt, dur) => {
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > dur - 1 ? tt - (dur - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
};
const gore = (ctx, cx, cy, p, seed, n = 40) => {
  for (let i = 0; i < n; i++) {
    const a = (i * 2.399 + seed) % (Math.PI * 2), sp = 20 + ((i * 37) % 60), x = cx + Math.cos(a) * sp * p, y = cy + Math.sin(a) * sp * p * 0.8 + p * p * 40;
    R(ctx, i % 3 ? "#991b1b" : "#5a0606", x, y, 2 + (i % 3), 2 + (i % 2));
  }
};
const pale = (ctx, x, y, t, i, a = 1) => {
  ctx.globalAlpha = a; const sw = Math.round(Math.sin(t / 500 + i));
  R(ctx, "#e5e7eb", x, y - 22, 8, 22); R(ctx, "#f1e4d8", x + 2, y - 29, 5, 7); R(ctx, "#0b0b0f", x + 1 + sw, y - 31, 7, 3); R(ctx, "#0b0b0f", x + sw, y - 28, 2, 14);
  R(ctx, "#7f1d1d", x + 3, y - 26, 1, 1); R(ctx, "#7f1d1d", x + 5, y - 26, 1, 1); ctx.globalAlpha = 1;
};
const COATS = ["#3b3f4a", "#5a4430", "#2f4a6b", "#4a3a5a", "#3d5a3d", "#6b3a2a"];
const body = (ctx, x, y, top, hair, skin = "#d9b48f") => { R(ctx, "#1f2430", x + 1, y - 6, 2, 6); R(ctx, "#1f2430", x + 4, y - 6, 2, 6); R(ctx, top, x, y - 15, 7, 9); R(ctx, skin, x + 1, y - 20, 5, 5); R(ctx, hair, x + 1, y - 21, 5, 2); };

export const ASSAULT_DURATION = 27;
export const assaultCaption = cap([
  [0.6, 4.0, "Romulus and Remus force their way down the stairs."],
  [4.2, 8.0, "Their people tear through the cult. One body at a time."],
  [8.2, 12.0, "The deeper they go, the more the mountain shakes."],
  [12.4, 15.6, "At last, they reach the carved door."],
  [16.4, 19.6, "\"You are too late,\" Samantha whispers."],
  [19.8, 22.2, "Dana and Samantha die in each other's arms."],
  [22.6, 26.0, "Romulus and Remus burst apart."],
]);

export function drawAssault(ctx, tt, now) {
  const amp = tt < 16 ? Math.min(5, tt / 3) : tt > 22.4 && tt < 24 ? 6 : 1;
  ctx.save(); ctx.translate(Math.round((Math.random() - 0.5) * amp), Math.round((Math.random() - 0.5) * amp));
  if (tt < 16) {
    R(ctx, "#0b0908", -8, -8, W + 16, H + 16);
    for (let i = 0; i < 16; i++) { const x = i * 20, y = 40 + i * 7; R(ctx, "#3a332d", x, y, 22, 3); R(ctx, "#1a1614", x, y + 3, 22, 140); }
    const lead = Math.min(15, tt) / 15, lx = 10 + lead * 270, ly = 40 + (lx / 20) * 7;
    pale(ctx, lx, ly, now, 0); pale(ctx, lx - 12, ly - 4, now, 1);
    for (let i = 0; i < 14; i++) { const x = lx - 26 - i * 11; if (x < -10) break; body(ctx, x, 40 + (x / 20) * 7, COATS[i % 6], i % 2 ? "#2a1a10" : "#9a8a70"); }
    for (let k = 0; k < 7; k++) {
      const cx = 60 + k * 36, cy = 40 + (cx / 20) * 7;
      if (lx < cx - 14) { R(ctx, "#7f1d1d", cx, cy - 13, 6, 13); R(ctx, "#5c0f0f", cx + 1, cy - 17, 4, 5); }
      else { R(ctx, "#7f1d1d", cx - 6, cy - 3, 12, 3); R(ctx, "#8b0a0a", cx - 10, cy, 22, 2); if (lx < cx + 30) gore(ctx, cx, cy - 8, (lx - cx + 14) / 44, k, 18); }
    }
    for (let i = 0; i < 20; i++) R(ctx, "#5a4a3a", (i * 53 + now * 0.08) % W, (i * 31 + now * 0.2) % H, 1, 2);
  } else {
    R(ctx, "#0b0807", -8, -8, W + 16, H + 16);
    const fl = 0.8 + Math.sin(now / 90) * 0.1, g = ctx.createRadialGradient(170, 120, 4, 170, 120, 140);
    g.addColorStop(0, `rgba(245,140,40,${0.35 * fl})`); g.addColorStop(1, "rgba(0,0,0,0)"); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    R(ctx, "#1a1210", 0, 146, W, 40); R(ctx, "#2a2420", 140, 122, 80, 24); R(ctx, "#3a322c", 136, 118, 88, 5);
    R(ctx, "#2f4a6b", 150, 112, 26, 7); R(ctx, "#c99a74", 176, 112, 7, 6); R(ctx, "#1a1210", 182, 111, 3, 7);
    R(ctx, "#141418", 152, 105, 26, 7); R(ctx, "#e8c4a0", 178, 105, 7, 6); R(ctx, "#e5e7eb", 184, 104, 4, 8); R(ctx, "#b91c1c", 176, 108, 2, 3);
    const pool = Math.min(1, (tt - 16) / 6); R(ctx, "#7a0b0b", 146, 118, 70 * pool, 2); R(ctx, "#7a0b0b", 214, 120, 3, 26 * pool); R(ctx, "#5a0606", 200, 144, 40 * pool, 3);
    R(ctx, "#2a1d13", 10, 70, 30, 76); R(ctx, "#050404", 14, 76, 22, 70);
    if (Math.sin(now / 150) > -0.3) R(ctx, "#fde047", 21, 64, 8, 3);
    const boom = tt > 22.6 ? Math.min(1, (tt - 22.6) / 1.4) : 0;
    if (!boom) { pale(ctx, 50, 146, now, 0); pale(ctx, 66, 146, now, 1); }
    else { gore(ctx, 54, 128, boom, 1, 60); gore(ctx, 70, 128, boom, 4, 60); if (boom < 0.35) { ctx.fillStyle = `rgba(255,255,255,${0.9 - boom * 2.5})`; ctx.fillRect(-8, -8, W + 16, H + 16); } }
  }
  ctx.restore();
  bars(ctx, tt, ASSAULT_DURATION);
}

export const GOD_DURATION = 31;
export const godCaption = cap([
  [0.6, 4.0, "Sam and Chloe run out into the snow, laughing. Dancing."],
  [4.4, 8.0, "Joe and Sarah can't look away from the horizon."],
  [8.4, 12.0, "Something is tearing its way into the sky."],
  [12.4, 16.0, "It is bigger than the mountain. It has too many eyes."],
  [16.4, 19.6, "Their eyes begin to bleed."],
  [20.0, 23.8, "\"I don't think it's what they were hoping for,\" Sarah says."],
  [24.4, 26.4, "Then she bursts."],
  [27.0, 30.4, "Joe starts laughing. He can't stop. He falls into the snow."],
]);

export function drawGod(ctx, tt, now) {
  const G = 146, rift = Math.max(0, Math.min(1, (tt - 7.5) / 8));
  ctx.save(); if (tt > 8 && tt < 27) ctx.translate(Math.round((Math.random() - 0.5) * 2 * rift), 0);
  ["#05060c", "#0a0a16", "#120c1c", "#1a0f22"].forEach((c, i) => R(ctx, c, -4, i * 30, W + 8, 30));
  if (rift > 0) {
    const cx = 160, w = 20 + rift * 240, h = 10 + rift * 90;
    const edge = (i, dir) => { const k = Math.sin((Math.PI * i) / 16); return 62 + dir * (k * h * 0.55 + ((i * 37) % 7) * k * 1.5); };
    ctx.fillStyle = "#e9d5ff"; ctx.beginPath(); ctx.moveTo(cx - w / 2, 62);
    for (let i = 0; i <= 16; i++) ctx.lineTo(cx - w / 2 + (w * i) / 16, edge(i, -1));
    for (let i = 16; i >= 0; i--) ctx.lineTo(cx - w / 2 + (w * i) / 16, edge(i, 1));
    ctx.fill();
    ctx.fillStyle = "#1a0510"; ctx.beginPath(); ctx.ellipse(cx, 62, w * 0.38, h * 0.45, 0, 0, Math.PI * 2); ctx.fill();
    if (tt > 11) for (let i = 0; i < 9; i++) {
      const ex = cx - w * 0.3 + ((i * 41) % (w * 0.6)), ey = 50 + ((i * 17) % (h * 0.5)), op = Math.sin(now / 400 + i) > -0.4;
      R(ctx, "#fef3c7", ex - 3, ey - 2, 7, 4); if (op) R(ctx, "#b91c1c", ex - 1, ey - 1, 3, 3);
    }
    for (let i = 0; i < 6; i++) { const tx = cx - w * 0.35 + i * w * 0.14; for (let k = 0; k < 14 * rift; k++) R(ctx, "#2a0a1a", tx + Math.sin(now / 300 + k / 2 + i) * 4, 70 + k * 4, 3, 4); }
  }
  for (let x = 0, i = 0; x < W; x += 16 + (i % 3) * 5, i++) { R(ctx, "#04070d", x + 4, G - 12, 3, 12); for (let k = 0; k < 4; k++) R(ctx, "#060a13", x + 5 - (2 + k * 3), G - 40 + k * 7, 4 + k * 6, 8); }
  R(ctx, "#1e150d", 250, G - 40, 70, 40); R(ctx, "#f59e0b", 262, G - 30, 10, 8); R(ctx, "#f59e0b", 296, G - 30, 10, 8);
  R(ctx, "#b6c6d6", -4, G, W + 8, H - G);
  [[120, "#2f4a6b", "#2a1a10"], [140, "#7f1d1d", "#e5e7eb"]].forEach(([x, top, hair], i) => {
    const hop = Math.abs(Math.sin(now / 180 + i * 1.3)) * 6, kx = x + Math.sin(now / 500 + i) * 10;
    ctx.save(); ctx.translate(kx, G - hop); ctx.scale(0.72, 0.72); body(ctx, 0, 0, top, hair, "#e8c4a0"); ctx.restore();
  });
  const bleed = tt > 16.4 ? Math.min(6, (tt - 16.4) * 1.5) : 0;
  const laugh = tt > 27 ? Math.round(Math.sin(now / 50)) : 0, fallen = tt > 29;
  if (!fallen) { body(ctx, 186 + laugh, G, "#3f4a35", "#2a1a10"); if (bleed) { R(ctx, "#b91c1c", 188 + laugh, G - 18, 1, bleed * 0.6); R(ctx, "#b91c1c", 191 + laugh, G - 18, 1, bleed * 0.6); } }
  else { R(ctx, "#3f4a35", 180, G - 4, 10, 4); R(ctx, "#d9b48f", 190, G - 4, 5, 4); R(ctx, "#1f2430", 172, G - 3, 8, 3); R(ctx, "#b91c1c", 191, G - 1, 4, 1); }
  if (tt < 24.4) { body(ctx, 204, G, "#7f1d1d", "#c9a25a", "#e8c4a0"); if (bleed) { R(ctx, "#b91c1c", 206, G - 18, 1, bleed * 0.6); R(ctx, "#b91c1c", 209, G - 18, 1, bleed * 0.6); } }
  else { const p = Math.min(1, (tt - 24.4) / 1.4); gore(ctx, 207, G - 10, p, 2, 70); R(ctx, "#7a0b0b", 190, G + 2, 40, 3); R(ctx, "#5a0606", 196, G + 6, 30, 2); }
  for (let i = 0; i < 80; i++) R(ctx, "#e8f1ff", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.02) % H, 1, 1);
  ctx.restore();
  bars(ctx, tt, GOD_DURATION);
}
